// robust-floorplan.js
(function () {
  // debug helper
  const log = (...args) => console.info('[Floorplan]', ...args);

  // Wait for Panzoom to exist (tries for ~3s)
  function waitForPanzoom(timeout = 3000) {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      (function check() {
        if (typeof window.Panzoom !== 'undefined') return resolve(window.Panzoom);
        if (Date.now() - start > timeout) return reject(new Error('Panzoom not found'));
        requestAnimationFrame(check);
      })();
    });
  }

  // Attach behavior to a single wrapper element
  function attachToWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.floorplanBound) return;
    const img = wrapper.querySelector('img');
    if (!img) {
      log('no image inside wrapper, skipping', wrapper);
      return;
    }

    wrapper.dataset.floorplanBound = 'true';
    log('attach handlers for', img.src);

    // Prevent clicks/dblclicks that may reset behavior
    img.addEventListener('click', (e) => e.preventDefault());
    img.addEventListener('dblclick', (e) => e.preventDefault());
    img.addEventListener('mousedown', (e) => e.stopPropagation());
    wrapper.addEventListener('pointerdown', (e) => e.stopPropagation());

    // Ensure good CSS: transform origin center
    img.style.transformOrigin = 'center center';
    img.style.display = 'block';
    img.style.width = '100%';
    img.style.height = 'auto';

    // init panzoom
    const panzoom = Panzoom(img, {
      maxScale: 6,
      minScale: 1,
      contain: 'outside'
    });

    img.style.cursor = 'grab';

    img.addEventListener('panzoomstart', () => {
      img.style.cursor = 'grabbing';
    });

    img.addEventListener('panzoomend', () => {
      img.style.cursor = 'grab';
    });

    // wheel support (optional enable)
    // wrapper.addEventListener('wheel', (ev) => {
    //   try { panzoom.zoomWithWheel(ev); } catch (err) { /* ignore */ }
    // }, { passive: false });

    const block = wrapper.closest('.floorplan-block');
    if (!block) return;

    // original zoom button (kept for backward compatibility)
    const zoomBtn = block.querySelector('.zoom-toggle');

    // NEW plus / minus buttons
    const zoomInBtn = block.querySelector('.zoom-in-btn');
    const zoomOutBtn = block.querySelector('.zoom-out-btn');

    const printBtn = block.querySelector('.print-btn');

    const zoomLevels = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6];
    let zoomIndex = 0;
    let zoomDirection = 1;

    // keep old single-button behaviour (if still used anywhere)
    if (zoomBtn && !zoomBtn.dataset.bound) {
      zoomBtn.dataset.bound = 'true';
      zoomBtn.addEventListener('click', () => {
        zoomIndex += zoomDirection;
        if (zoomIndex >= zoomLevels.length - 1) zoomDirection = -1;
        if (zoomIndex <= 0) zoomDirection = 1;

        const targetScale = zoomLevels[zoomIndex];

        const rect = img.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        try {
          panzoom.zoomToPoint(targetScale, {
            clientX: centerX,
            clientY: centerY
          });
        } catch (err) {
          console.error('[Floorplan] zoom error', err);
        }
      });
    }

    // track scale for +/- buttons
    let currentScale = 1;
    const minScale = 1;
    const maxScale = 6;
    const step = 0.5;

    function zoomTo(scale) {
      const rect = img.getBoundingClientRect();

      const center = {
        clientX: rect.left + rect.width / 2,
        clientY: rect.top + rect.height / 2
      };

      try {
        panzoom.zoomToPoint(scale, center);
        currentScale = scale;
      } catch (err) {
        console.error('[Floorplan] zoom error', err);
      }
    }

    // zoom in
    if (zoomInBtn && !zoomInBtn.dataset.bound) {
      zoomInBtn.dataset.bound = 'true';
      zoomInBtn.addEventListener('click', () => {
        const newScale = Math.min(currentScale + step, maxScale);
        zoomTo(newScale);
      });
    }

    // zoom out
    if (zoomOutBtn && !zoomOutBtn.dataset.bound) {
      zoomOutBtn.dataset.bound = 'true';
      zoomOutBtn.addEventListener('click', () => {
        const newScale = Math.max(currentScale - step, minScale);
        zoomTo(newScale);
      });
    }

    // print logic (unchanged)
    if (printBtn && !printBtn.dataset.bound) {
      printBtn.dataset.bound = 'true';
      printBtn.addEventListener('click', () => {
        let printed = false;
        const iframe = document.createElement('iframe');
        Object.assign(iframe.style, {
          position: 'fixed',
          right: '0',
          bottom: '0',
          width: '0',
          height: '0',
          border: '0'
        });

        document.body.appendChild(iframe);
        const doc = iframe.contentWindow.document;
        doc.open();

        doc.write(`
            <html>
              <head>
                <style>
                  @page { margin: 0; }
                  body { margin: 0; padding: 0; }
                  img { width: 100%; height: auto; display: block; }
                </style>
              </head>
              <body>
                <img id="print-img" src="${img.src}">
              </body>
            </html>
          `);

        doc.close();
        const imgInFrame = iframe.contentWindow.document.getElementById('print-img');
        const doPrint = () => {
          if (printed) return;
          printed = true;
          try {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          } catch (e) {
            console.error('[Floorplan] print failed', e);
          }

          setTimeout(() => {
            if (iframe && iframe.parentNode)
              iframe.parentNode.removeChild(iframe);
          }, 700);
        };

        if (imgInFrame.complete) {
          setTimeout(doPrint, 60);
        } else {
          imgInFrame.onload = doPrint;
          imgInFrame.onerror = () => {
            console.warn('[Floorplan] image failed to load into iframe for printing');
            doPrint();
          };
        }
      });
    }

    const copyBtn = block.querySelector('.copy-link-btn');

    if (copyBtn && !copyBtn.dataset.bound) {
      copyBtn.dataset.bound = 'true';

      let textSpan = copyBtn.querySelector('.copy-text');
      if (!textSpan) {
        const textNode = Array.from(copyBtn.childNodes).find(n => n.nodeType === Node.TEXT_NODE);
        if (textNode) {
          textSpan = document.createElement('span');
          textSpan.className = 'copy-text';
          textSpan.textContent = textNode.textContent.trim();
          copyBtn.replaceChild(textSpan, textNode);
        }
      }

      copyBtn.addEventListener('click', async () => {
        const url = copyBtn.dataset.url;
        try {
          await navigator.clipboard.writeText(url);

          if (textSpan) {
            const originalText = textSpan.textContent;
            textSpan.textContent = 'Copied!';
            setTimeout(() => {
              textSpan.textContent = originalText;
            }, 1500);
          }

        } catch (err) {
          console.error('[Floorplan] copy failed', err);
          // fallback for older browsers
          const tmp = document.createElement('textarea');
          tmp.value = url;
          document.body.appendChild(tmp);
          tmp.select();
          document.execCommand('copy');
          document.body.removeChild(tmp);
          alert('Link copied!');
        }
      });
    }
  }

  // Attach to all existing wrappers
  function attachAll() {
    const wrappers = document.querySelectorAll('.floorplan-image-wrapper');
    wrappers.forEach(attachToWrapper);
  }

  // Observe DOM changes (blocks inserted later)
  function observeDOM() {
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.addedNodes.length) {
          setTimeout(attachAll, 60);
          break;
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

  }

  // bootstrap
  waitForPanzoom(3000)
    .then(() => {
      log('Panzoom loaded. Attaching handlers...');
      attachAll();
      observeDOM();
    })

    .catch((err) => {
      console.error('[Floorplan] cannot initialize Panzoom:', err);
    });


})();

